import * as types from '../mutation-types'
import discountsRepository from '../../api/discountsRepository'

const state = {
    discountToCreate: [],
    customerSpecificPricesToCreate: [],
    discounts: [],
    isDiscountCreated: false,
    isCustomerSpecificPricesCreated: false,
    customerSpecificPrices: []
}

const getters = {
    discountToCreate: state => state.discountToCreate,
    customerSpecificPricesToCreate: state => state.customerSpecificPricesToCreate,
    discounts: state => state.discounts,
    isDiscountCreated: state => state.isDiscountCreated,
    isCustomerSpecificPricesCreated: state => state.isCustomerSpecificPricesCreated,
    customerSpecificPrices: state => state.customerSpecificPrices
}

const actions = {
    createUpdateDiscount({ commit }) {
        return discountsRepository.createUpdateDiscount(state.discountToCreate).then((response) => {
            if (response.data.success) {
                commit(types.SET_DISCOUNT_CREATED, true)
            } else {
                commit(types.SET_DISCOUNT_CREATED, false)
            }
        })
    },
    createUpdateCustomerSpecificPrices({ commit }) {
        return discountsRepository.createUpdateCustomerSpecificPrices(state.customerSpecificPricesToCreate).then((response) => {
            if (response.data.success) {
                commit(types.SET_CUSTOMER_SPECIFIC_PRICES_CREATED, true)
            } else {
                commit(types.SET_CUSTOMER_SPECIFIC_PRICES_CREATED, false)
            }
        })
    },
    getDiscounts({ commit }) {
        return discountsRepository.getDiscounts().then((response) => {
            commit(types.SET_DISCOUNTS, response.data)
        })
    },
    getDiscountsForCustomer({ commit }, customerId) {
        return discountsRepository.getDiscountsForCustomer(customerId).then((response) => {
            commit(types.SET_DISCOUNTS, response.data)
        })
    },
    getPricesForCustomer({ commit }, customerId) {
        return discountsRepository.getPricesForCustomer(customerId).then((response) => {
            commit(types.SET_CUSTOMER_SPECIFIC_PRICES, response.data)
        })
    },
    getPricesForCustomerOnAuth({ commit }) {
        return discountsRepository.getPricesForCustomerOnAuth().then((response) => {
            commit(types.SET_CUSTOMER_SPECIFIC_PRICES, response.data)
        })
    }
}

const mutations = {
    [types.SET_DISCOUNT_TO_CREATE](state, payload) {
        state.discountToCreate = payload
    },
    [types.SET_DISCOUNTS](state, payload) {
        state.discounts = payload
    },
    [types.SET_DISCOUNT_CREATED](state, payload) {
        state.isDiscountCreated = payload
    },
    [types.ADD_DISCOUNT_TO_DISCOUNTS](state, payload) {
        state.discounts.push(payload)
    },
    [types.SET_CUSTOMER_SPECIFIC_PRICES](state, payload) {
        state.customerSpecificPrices = payload
    },
    [types.ADD_PRICE_TO_CUSTOMER_SPECIFIC_PRICES](state, payload) {
        state.customerSpecificPrices.push(payload)
    },
    [types.REMOVE_PRICE_TO_CUSTOMER_SPECIFIC_PRICES](state, payload) {
        state.customerSpecificPrices.splice(payload.index, 1)
    },
    [types.SET_CUSTOMER_SPECIFIC_PRICES_TO_CREATE](state, payload) {
        state.customerSpecificPricesToCreate = payload
    },
    [types.SET_CUSTOMER_SPECIFIC_PRICES_CREATED](state, payload) {
        state.isCustomerSpecificPricesCreated = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
